import React, { useEffect } from 'react';
import { Navigation } from '../components/Navigation';
import { Hero } from '../components/Hero';
import { ProgramsSection } from '../components/ProgramsSection';
import { LocalAuthoritySection } from '../components/LocalAuthoritySection';
import { BenefitsSection } from '../components/BenefitsSection';
import { FacilitySection } from '../components/FacilitySection';
import { CTASection } from '../components/CTASection';
import { Footer } from '../components/Footer';
export function HomePage() {
  useEffect(() => {
    document.title = "Walker's Martial Arts | Taekwondo & Kickboxing | Bloomington, Illinois";
  }, []);
  return <div className="bg-black" data-id="element-591">
      <Navigation data-id="element-592" />
      <Hero data-id="element-593" />
      <ProgramsSection data-id="element-594" />
      <LocalAuthoritySection data-id="element-595" />
      <BenefitsSection data-id="element-596" />
      <FacilitySection data-id="element-597" />
      <CTASection data-id="element-598" />
      <Footer data-id="element-599" />
    </div>;
}